/**
 * Realistic sample payload for dev preview / sample feed posts.
 */
export const getQuarterGoalsReportSamplePayload = () => ({
  quarterKey: 'dev-sample-Q1-2026',
  quarterLabel: 'Q1 2026',
  quarter: 1,
  year: 2026,
  startDate: '2026-01-01T00:00:00.000Z',
  endDate: '2026-03-31T23:59:59.999Z',
  shoutoutText:
    'Shoutout to @[Jordan](uid-jordan), @[Alex](uid-alex), and @[Sam](uid-sam) for topping the charts this quarter!',
  clubStats: {
    averageConsistency: 78.4,
    totalCheckIns: 312,
    activeHabitGoals: 14,
    participationRate: 83.3,
    memberCount: 6,
    participatingMemberCount: 5,
  },
  leaderboard: [
    {
      userId: 'uid-jordan',
      rank: 1,
      consistencyScore: 94.2,
      habitGoalCount: 2,
      user: { uid: 'uid-jordan', displayName: 'Jordan', photoUrl: null },
    },
    {
      userId: 'uid-alex',
      rank: 2,
      consistencyScore: 88.5,
      habitGoalCount: 3,
      user: { uid: 'uid-alex', displayName: 'Alex', photoUrl: null },
    },
    {
      userId: 'uid-sam',
      rank: 3,
      consistencyScore: 81.0,
      habitGoalCount: 2,
      user: { uid: 'uid-sam', displayName: 'Sam', photoUrl: null },
    },
    {
      userId: 'uid-morgan',
      rank: 4,
      consistencyScore: 72.3,
      habitGoalCount: 1,
      user: { uid: 'uid-morgan', displayName: 'Morgan', photoUrl: null },
    },
    {
      userId: 'uid-riley',
      rank: 5,
      consistencyScore: 65.1,
      habitGoalCount: 2,
      user: { uid: 'uid-riley', displayName: 'Riley', photoUrl: null },
    },
  ],
  topStreaks: [
    {
      userId: 'uid-alex',
      streakRank: 1,
      streak: 42,
      user: { uid: 'uid-alex', displayName: 'Alex', photoUrl: null },
    },
    {
      userId: 'uid-jordan',
      streakRank: 2,
      streak: 38,
      user: { uid: 'uid-jordan', displayName: 'Jordan', photoUrl: null },
    },
    {
      userId: 'uid-sam',
      streakRank: 3,
      streak: 21,
      user: { uid: 'uid-sam', displayName: 'Sam', photoUrl: null },
    },
  ],
  perfectQuarters: [
    {
      userId: 'uid-jordan',
      consistencyScore: 100,
      user: { uid: 'uid-jordan', displayName: 'Jordan', photoUrl: null },
    },
  ],
  personalBests: [
    {
      userId: 'uid-alex',
      streak: 42,
      user: { uid: 'uid-alex', displayName: 'Alex', photoUrl: null },
    },
    {
      userId: 'uid-sam',
      streak: 21,
      user: { uid: 'uid-sam', displayName: 'Sam', photoUrl: null },
    },
  ],
  booksFinished: {
    total: 3,
    items: [
      {
        userId: 'uid-morgan',
        bookId: 1,
        title: 'Dune',
        author: 'Frank Herbert',
        user: { uid: 'uid-morgan', displayName: 'Morgan', photoUrl: null },
      },
      {
        userId: 'uid-riley',
        bookId: 2,
        title: 'The Midnight Library',
        author: 'Matt Haig',
        user: { uid: 'uid-riley', displayName: 'Riley', photoUrl: null },
      },
      {
        userId: 'uid-alex',
        bookId: 3,
        title: 'Project Hail Mary',
        author: 'Andy Weir',
        user: { uid: 'uid-alex', displayName: 'Alex', photoUrl: null },
      },
    ],
  },
  topPerformers: {
    mostConsistent: {
      userId: 'uid-jordan',
      value: 94.2,
      user: { displayName: 'Jordan', photoUrl: null },
    },
    streakChampion: {
      userId: 'uid-alex',
      value: 42,
      user: { displayName: 'Alex', photoUrl: null },
    },
    topMetricEarner: {
      userId: 'uid-sam',
      value: 112.5,
      user: { displayName: 'Sam', photoUrl: null },
    },
    milestoneMaster: {
      userId: 'uid-morgan',
      value: 4,
      user: { displayName: 'Morgan', photoUrl: null },
    },
  },
});
